import { C16VideoAssetProps } from './C16VideoAsset';
import { VideoAssetProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export function CreateVideoAssetModel(props?: C16VideoAssetProps) {
  const { fields } = props || {};
  const { renderRichText } = useConditionalRendering();

  return {
    videoId: props?.fields?.VideoID?.value as VideoAssetProps['videoId'],
    caption: renderRichText(fields?.Caption),
  };
}
